import Context from "shared/util/Context";
import { GENTATION } from "shared/dictionaries/gentation";

const Identity = {
	VALS: GENTATION,

	getOrientation(config) {
		return this.getGorO("orientation", config);
	},

	getGender(config) {
		return this.getGorO("gender", config);
	},

	getGorO(goro, _config) {
		let config = { ..._config };

		if (typeof (config.value) !== "undefined" && config.value !== null) {
			config[goro] = config.value;
		}

		const defaultFormats = {
			gender: "Letter",
			orientation: "Full",
		};

		let subject = "orientation";
		let SUBJECT = "ORIENTATION";

		if (goro === "gender") {
			subject = "gender";
			SUBJECT = "GENDER";
		}

		config = config || {};

		if (!(config.format && GENTATION[`${SUBJECT}_MAPPINGS`][config.format.toLowerCase()])) {
			config.format = defaultFormats[subject];
		}

		config[subject] = config[subject] || 0;
		config.tags = config.tags || [];

		const capitalize = /^[A-Z]/.test(config.format);
		const value = GENTATION[`${SUBJECT}_ALIASES`][config[subject]] || 0;
		let display = GENTATION[`${SUBJECT}_MAPPINGS`][config.format.toLowerCase()][value];

		// parse all as int, remove 999
		config.tags = config.tags.map((tag) => parseInt(tag, 10));
		config.tags = config.tags.filter((tag) => tag !== 999);

		if (config.tags.length) {
			const tagNames = [];

			config.tags.forEach((tag) => {
				tagNames.push(GENTATION[`${SUBJECT}_TAGS`][tag]);
			});

			display = tagNames.join(", ");
		}

		// if the format is sentence case, keep it that way
		if (typeof (display) === "string" && !capitalize) {
			display = display.toLowerCase();
		}

		return display;
	},

	getInterestedIn(genderCode, orientationCode) {
		if (orientationCode === GENTATION.ORIENTATION_ALIASES.Bisexual) {
			// there's no gender alias for "Everyone" yet. I think it would fuck
			// stuff up? at any rate it doesn't make sense, this means "everyone,"
			// "anyone," and "intersex" so just return 3
			return 3;
		}

		if (orientationCode === GENTATION.ORIENTATION_ALIASES.Gay) {
			return genderCode;
		}

		// if they're still here, they're straight
		if (genderCode === GENTATION.GENDER_ALIASES.Man) {
			return GENTATION.GENDER_ALIASES.Woman;
		} else {
			return GENTATION.GENDER_ALIASES.Man;
		}
	},

	getInterestsFromGentation(_gentation) {
		const gentation = parseInt(_gentation, 10);
		let iWant = 1;
		let theyWant = 1;

		if (gentation === 21 || gentation === 42) {
			if (gentation === 21) {
				iWant = 1;
			} else {
				iWant = 2;
			}

			if (Context.get("user_demo")) {
				theyWant = Context.get("user_demo").gender;
			}

			return {
				i_want: iWant,
				they_want: theyWant,
			};
		}

		// chain some operations to get a simplified gentation
		Object.keys(GENTATION.GENTATION_SHIM_GENDER).forEach((subject) => {
			const gentationList = GENTATION.GENTATION_SHIM_GENDER[subject];

			if (gentationList.indexOf(gentation) >= 0) {
				iWant = subject;
			}
		});

		Object.keys(GENTATION.GENTATION_SHIM_ORIENTATION).forEach((subject) => {
			const gentationList = GENTATION.GENTATION_SHIM_ORIENTATION[subject];

			if (gentationList.indexOf(gentation) >= 0) {
				theyWant = subject;
			}
		});

		return {
			i_want: parseInt(iWant, 10),
			they_want: parseInt(theyWant, 10),
		};
	},

	getGentationFromInterests(params) {
		// needs params.i_want and params.they_want
		if (!params.i_want || !params.they_want) {
			return 63;
		}

		return GENTATION.GENTATIONS_BY_INTEREST[params.they_want][params.i_want];
	},

	getInterestName(gender) {
		const genders = {
			"1": "Men",
			"2": "Women",
			"3": "Everyone",
		};

		return genders[gender] || "Everyone";
	},
};

export default Identity;



// WEBPACK FOOTER //
// ./src/shared/util/Identity.js